export default __webpack_public_path__ + "static/Facebook Form-hero-aac6ba09cd914868af6e90b624829a67.webp";